// MTL.TAXI Configuration
// Edit these values to customize the website

export const siteConfig = {
  businessName: 'MTL.TAXI',
  phone: '438-600-4440',
  phoneFormatted: '+1 438-600-4440',
  phoneTel: 'tel:+14386004440',
  email: 'info@mtl.taxi',
  
  // External links
  bookingUrl: 'https://montaxi.hypra.ca/',
  appStoreUrl: 'https://apps.apple.com/ca/app/montaxi/id1597662770',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.hyprasoft.montaxi',
  ratesInfoUrl: 'https://montaxi.ca/taxi/tarif/',
  
  // Social media (optional)
  facebookUrl: '',
  yelpUrl: '',
  
  // Hours
  hours: '24/7',
  
  // Payment methods
  paymentMethods: ['Cash', 'Debit', 'Visa', 'Mastercard', 'Amex'],
  
  // Service areas
  serviceAreas: [
    'Montréal',
    'Saint-Laurent',
    'Laval',
    'Longueuil',
    'West Island',
    'Rive-Sud',
    'Rive-Nord',
  ],
  
  // Map center (Montreal)
  mapCenter: [45.5017, -73.5673],
  mapZoom: 10,
  
  // Service area markers
  serviceMarkers: [
    { name: 'Montréal Centre', lat: 45.5017, lng: -73.5673, main: true },
    { name: 'Saint-Laurent', lat: 45.5087, lng: -73.6672 },
    { name: 'Laval (Chomedey)', lat: 45.5582, lng: -73.7371 },
    { name: 'Longueuil', lat: 45.5312, lng: -73.5186 },
    { name: 'Dorval (YUL)', lat: 45.4573, lng: -73.7408, airport: true },
    { name: 'West Island', lat: 45.4940, lng: -73.8106 },
    { name: 'Brossard', lat: 45.4584, lng: -73.4551 },
  ],
  
  // Taxi rates (regulated by CTQ)
  rates: {
    day: {
      departure: 4.10,
      perKm: 2.05,
      waitingHour: 46.20,
      hours: '5h - 22h59',
    },
    night: {
      departure: 4.70,
      perKm: 2.35,
      waitingHour: 53.40,
      hours: '23h - 4h59',
    },
    additionalFee: 1.05,
  },
  
  // Express services pricing
  expressServices: {
    batteryBoost: 25,
    doorUnlock: 30,
    parcelDelivery: 6.50, // additional to meter
  },
};
